import React from 'react';
import Icon from '../shared/Icon';
import Avatar from '../shared/Avatar';
import Toggle from '../shared/Toggle';

const PAGE_NAMES = {
  overview: 'Analytics Overview',
  users:    'Conversation History',
  feedback: 'Feedback Management',
  devids:   'Developer ID Management',
};

export default function AdminHeader({ activePage, product, excludeDevs, setExcludeDevs, devCount, onToggleSidebar, accent, onLogout, onBackToChat }) {
  const ac = accent || '#CC1A00';
  return (
    <header style={{
      height: 60, background: 'white', borderBottom: '1px solid #E8EAED',
      display: 'flex', alignItems: 'center', padding: '0 20px', gap: 12,
      position: 'sticky', top: 0, zIndex: 10, flexShrink: 0,
    }}>
      <button
        onClick={onToggleSidebar}
        style={{
          width: 34, height: 34, border: 'none', background: '#F4F6F9',
          borderRadius: 8, cursor: 'pointer', display: 'flex',
          alignItems: 'center', justifyContent: 'center', flexShrink: 0,
        }}
      >
        <Icon name="menu" size={18} color="#6B7280" />
      </button>

      <h1 style={{ fontSize: 16, fontWeight: 700, color: '#111827', flex: 1, margin: 0 }}>
        {product ? `${product} · ${PAGE_NAMES[activePage] || ''}` : (PAGE_NAMES[activePage] || '')}
      </h1>

      {/* Dev filter pill */}
      <div style={{
        display: 'flex', alignItems: 'center', gap: 8,
        background: '#F9FAFB', border: '1px solid #E8EAED',
        borderRadius: 10, padding: '7px 14px',
      }}>
        <Icon name="filter" size={13} color="#9CA3AF" />
        <span style={{ fontSize: 13, color: '#374151', fontWeight: 500, whiteSpace: 'nowrap' }}>Exclude Devs</span>
        <Toggle checked={excludeDevs} onChange={setExcludeDevs} accent={ac} />
        {excludeDevs && (
          <span style={{
            fontSize: 11, background: ac + '18',
            color: ac, padding: '2px 8px', borderRadius: 5, fontWeight: 700,
          }}>
            {devCount} filtered
          </span>
        )}
      </div>

      {/* Back to chat */}
      {onBackToChat && (
        <button
          onClick={onBackToChat}
          title="Back to Chat"
          style={{
            height: 34, border: 'none', background: '#F4F6F9',
            borderRadius: 8, cursor: 'pointer', display: 'flex',
            alignItems: 'center', justifyContent: 'center', flexShrink: 0,
            gap: 6, padding: '0 12px', fontFamily: 'inherit',
            fontSize: 13, fontWeight: 600, color: '#374151',
          }}
        >
          <Icon name="arrowLeft" size={16} color="#6B7280" />
          Back to Chat
        </button>
      )}

      {/* Logout button */}
      {onLogout && (
        <button
          onClick={onLogout}
          title="Logout"
          style={{
            width: 34, height: 34, border: 'none', background: '#F4F6F9',
            borderRadius: 8, cursor: 'pointer', display: 'flex',
            alignItems: 'center', justifyContent: 'center', flexShrink: 0,
          }}
        >
          <Icon name="logout" size={18} color="#6B7280" />
        </button>
      )}

      <Avatar name="Admin User" size={32} bg={ac} />
    </header>
  );
}
